import { InstantSearch } from './InstantSearch';

export type { TypeInstantSearchProps } from './types';
export default InstantSearch;
